export const DEFAULT_ACCORDION_CLASS = 'cmp-accordion';
export const CQ_KEY = 'cq:panelTitle';
export const DATA_ATTR_VALUE = 'accordion';
export const DATA_CMP_IS = 'data-cmp-is';
export const DATA_PANEL_CONTAINER = 'data-panelcontainer';
